module.exports = __webpack_public_path__ + "img/icon_compensatory_hours.e650bde4.svg";